import type { InputHTMLAttributes } from 'react';

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  hint?: string;
  invalid?: boolean;
}

export function Field({ label, hint, invalid, id, ...rest }: FieldProps) {
  const inputId = id ?? `f-${label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
  return (
    <div className="field">
      <label className="field__label" htmlFor={inputId}>
        {label}
      </label>
      <input
        id={inputId}
        className="field__input"
        aria-invalid={invalid ? 'true' : undefined}
        {...rest}
      />
      {hint ? <p className="field__hint">{hint}</p> : null}
    </div>
  );
}

/** The four kinds the stylesheet defines; `error` is the only assertive one. */
export type AlertKind = 'error' | 'success' | 'info' | 'warning';

export function Alert({ kind, title, items }: { kind: AlertKind; title: string; items?: unknown }) {
  const list = Array.isArray(items) ? (items as string[]) : [];
  return (
    <div className={`alert alert--${kind}`} role={kind === 'error' ? 'alert' : 'status'}>
      {title}
      {list.length > 0 ? (
        <ul>
          {list.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
